import React, { useState } from "react";
import { Range } from "rc-slider";
import "rc-slider/assets/index.css";

const DoubleRangeSlider = (props) => {
  const [SelectedRange, setSelectedRange] = useState([
    props.MinValue,
    props.MaxValue,
  ]);

  const handleRangeChange = (Range) => {
    setSelectedRange(Range);
    props.HandleChange();
  };

  return (
    <div className="range-slider-wrapper">
      <div id={props.Id + "-min"} className="yoe-range">
        {SelectedRange[0]}
      </div>
      <p className="slider-label">{props.Title}</p>
      <Range
        step={1}
        min={props.MinValue}
        defaultValue={[props.MinValue, props.MaxValue]}
        max={props.MaxValue}
        onChange={(Range) => handleRangeChange(Range)}
      />
      <div id={props.Id + "-max"} className="yoe-range">
        {SelectedRange[1]}
      </div>
    </div>
  );
};

export default DoubleRangeSlider;
